import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
const swiper = new Swiper('.mySwiper', {
    slidesPerView: 5,
    centeredSlides: true,
    loop: true,
    autoplay: {
        delay: 3000,            // 2秒切换一次
        disableOnInteraction: false, // 手动滑动后不停止自动播放
        pauseOnMouseEnter: true, // 鼠标悬停暂停
    },
    speed: 600,   
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            slidesPerView: 5,
        },
        768: {  //当屏幕宽度小于等于1280
            slidesPerView: 3,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 3,
        }
    }, 
});